"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionStage = void 0;
/**
 * A clinical condition, problem, diagnosis, or other event, situation, issue, or clinical concept that has risen to a level of concern.
 */
var ConditionStage = /** @class */ (function () {
    function ConditionStage() {
    }
    return ConditionStage;
}());
exports.ConditionStage = ConditionStage;
